import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { TextBlock } from 'bench-internal-theme';

// Inherited from TextBlock
const LINE_HEIGHT = 32;

const PADDING_TOP_HEIGHT = 24;

const PADDING_BOTTOM_HEIGHT = 8;

const CategoryHeaderLayout = styled(TextBlock).attrs(() => ({
  styleType: 'title',
}))`
  margin: 0 ${({ margin }) => margin}px;
  padding: ${PADDING_TOP_HEIGHT}px 0 ${PADDING_BOTTOM_HEIGHT}px;
  text-overflow: ellipsis;
`;

type CategoryHeaderProps = {
  text: string;
  margin?: number;
};

class CategoryHeader extends PureComponent<CategoryHeaderProps> {
  static getHeight = () => PADDING_TOP_HEIGHT + PADDING_BOTTOM_HEIGHT + LINE_HEIGHT;

  render() {
    const { text, margin = 32 } = this.props;
    return <CategoryHeaderLayout margin={margin}>{text}</CategoryHeaderLayout>;
  }
}

export default CategoryHeader;
